/**
 * Biznes ma'lumotlari uchun deeplink URL'larini yaratadi.
 */

/** Telefon raqamiga qo'ng'iroq qilish */
export function phoneDeeplink(phone: string): string {
  return `tel:${phone.replace(/\s/g, '')}`;
}

/** Xarita deeplink — koordinatalar bo'yicha */
export function mapDeeplink(lat: number, lng: number, name?: string): string {
  // Google Maps → Yandex Maps → geo: fallback
  const query = name ? encodeURIComponent(name) : `${lat},${lng}`;
  // Google Maps universal link
  return `https://maps.google.com/maps?q=${lat},${lng}&query=${query}`;
}

/** geo: fallback (universal) */
export function geoDeeplink(lat: number, lng: number): string {
  return `geo:${lat},${lng}`;
}
